// Once-per-login bookkeeping for the Events & Announcements login popup.
//
// The popup is checked once per signed-in tab session: right after a fresh
// login (setSession clears the marker) and once when a tab boots with a
// persisted session, so a user who stays signed in for days still sees new
// content. sessionStorage is per tab, which is exactly the scope wanted.
// Repeat-showing of the SAME content is prevented server-side (popup views),
// not here - this only avoids re-asking on every navigation.

const KEY = "hrms.loginPopupChecked";

export function hasCheckedLoginPopup(userId: string): boolean {
  try {
    return sessionStorage.getItem(KEY) === userId;
  } catch {
    return false;
  }
}

export function markLoginPopupChecked(userId: string): void {
  try {
    sessionStorage.setItem(KEY, userId);
  } catch {
    // Storage unavailable (private mode quota): worst case the popup asks
    // again on the next boot, and the server still filters seen content.
  }
}

export function resetLoginPopupCheck(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // see markLoginPopupChecked
  }
}
